import { createFileRoute } from '@tanstack/react-router';
import { Page } from '@trukt/ui/Page';
import PageContainer from '../shared/components/Layouts/PageContainer';
import LKQFuelRate from '../admin/lkq/fuel-rate/fuel-rate';
const Component = () => (
  <Page route={{ Component: LKQFuelRate, title: 'LKQ Fuel Rate', Container: PageContainer }} />
);
export const Route = createFileRoute('/admin/lkq-fuel-rate')({ component: Component });
